import React from "react";
import ReactPlayer from "react-player";

const YouTubePlayer = ({ videoUrl }) => {
  return (
    <div className="flex justify-center react-video-player-main">
      <ReactPlayer url={videoUrl} controls width="100%" height="600px" />
    </div>
  );
};

export default YouTubePlayer;